export const defaultSelectOptions = {
    defaultScore: [
        { value: '1', name: 'excellent', translateText: 'condition.excellent' },
        { value: '2', name: 'good', translateText: 'condition.good' },
        { value: '3', name: 'reasonable', translateText: 'condition.reasonable' },
        { value: '4', name: 'moderate', translateText: 'condition.moderate' },
        { value: '5', name: 'poor', translateText: 'condition.poor' },
        { value: '6', name: 'bad', translateText: 'condition.bad' },
        { value: 'U', name: 'unknown', translateText: 'condition.unknown' },
        { value: 'F', name: 'further', translateText: 'condition.further' },
    ],
    noScore: [
        { value: '1', name: 'excellent', translateText: 'condition.excellent' },
        { value: 'U', name: 'unknown', translateText: 'condition.unknown' },
        { value: 'F', name: 'further', translateText: 'condition.further' },
    ],
};
